import MobileInstrumentsCategoriesDesigner from "./MobileInstrumentsCategoriesDesigner";
import { MobileInstrumentsCategoriesDefinitions } from "./MobileInstrumentsCategoriesDefinitions";

export class MobileInstrumentsCategories extends MobileInstrumentsCategoriesDefinitions {
    render() {
        return (
            <div
                data-schema-id={this.props.id}
                className={`fa-draggable fa-Section row ${this.props.designing ? "designing" : ""}`}
                style={{
                    minHeight: this.props.designing ? "300px" : "auto",
                    position: "relative",
                }}
            >
                {this.props.designing ? (
                    <MobileInstrumentsCategoriesDesigner {...this.props} />
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
